export async function isAccessingFromEurope() {
  try {
    const response = await fetch('https://ipinfo.io/json');
    const data = await response.json();
    const europeanCountries = [
      'AT',
      'BE',
      'BG',
      'CY',
      'CZ',
      'DE',
      'DK',
      'EE',
      'ES',
      'FI',
      'FR',
      'GR',
      'HR',
      'HU',
      'IE',
      'IT',
      'LT',
      'LU',
      'LV',
      'MT',
      'NL',
      'PL',
      'PT',
      'RO',
      'SE',
      'SI',
      'SK',
    ];
    return europeanCountries.includes(data.country);
  } catch (error) {
    return false;
  }
}
